export default __webpack_public_path__ + "assets/605d742fc47128d688ce75bbc18c4bbf.svg";